module.exports = __webpack_public_path__ + "fullstack.2IMKF7Fz.svg";